import { render } from "./PageSlide.vue?vue&type=template&id=23617d22"
import script from "./PageSlide.vue?vue&type=script&lang=js"
export * from "./PageSlide.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/digiasia.asia.bak/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__